import axios from "../axiosConfig";
import { Notification } from "../../types/notification";

export async function getNotifications(
  page: number = 1,
  limit: number = 10
): Promise<Notification[]> {
  const response = await axios.get("/notifications", {
    params: { page, limit },
  });
  return response.data;
}
export async function markNotificationAsRead(id: string): Promise<void> {
  await axios.put(`/notifications/${id}/mark-as-read`);
}

export async function markAllNotificationsAsRead(): Promise<void> {
  await axios.put("/notifications/read-all");
}
